import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, Typography } from "@bookips/sds";
import Image from "next/image";
import Link from "next/link";
import GNBLogo from "../GNBLogo";
import { GNBMenuButtonWrapper } from "../GNBMenuButtons";
import GNBSearchBox from "../GNBSearchBox";
import GNBUserTypeToggle from "../GNBUserTypeToggle";
const TabletNav = (param)=>{
    let { homeType , onToggle , onMenuClick , gnbBanner  } = param;
    return /*#__PURE__*/ _jsxs("nav", {
        className: "hidden h-[72px] items-center justify-between px-8 sm:flex lg:hidden",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-6",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-4",
                        children: [
                            /*#__PURE__*/ _jsx(GNBLogo, {
                                variant: "desktop"
                            }),
                            /*#__PURE__*/ _jsx(GNBUserTypeToggle, {
                                value: homeType,
                                onChange: onToggle,
                                layoutIdPrefix: "tablet"
                            })
                        ]
                    }),
                    (gnbBanner === null || gnbBanner === void 0 ? void 0 : gnbBanner.imageUrl) && /*#__PURE__*/ _jsx(Link, {
                        href: gnbBanner.link,
                        target: "_blank",
                        className: "hidden h-[40px] w-[140px] md:block",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: gnbBanner.imageUrl,
                            alt: gnbBanner.imageUrl,
                            width: 140,
                            height: 40
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-5",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-1 justify-end",
                        children: /*#__PURE__*/ _jsx(GNBSearchBox, {
                            openWidth: 300,
                            closedWidth: 300
                        })
                    }),
                    /*#__PURE__*/ _jsxs(GNBMenuButtonWrapper, {
                        onClick: onMenuClick,
                        children: [
                            /*#__PURE__*/ _jsx(Icon.Menu_2px, {
                                className: "size-6"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "caption",
                                className: "max-sm:hidden",
                                children: "메뉴"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default TabletNav;
